/**
 * useOnboardingStatus (P106) -- the bank-level Getting Started ladder.
 *
 * Drives the Getting Started tab, its nav entry (shown only while the
 * bank is `fresh`), and the Home teaser. Bank-level + cheap; cached a
 * few minutes like useMe.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import { onboardingKeys } from "shared/api/queryClient";
import type { OnboardingStatus } from "shared/api/types";

export function useOnboardingStatus(
  enabled = true,
): UseQueryResult<OnboardingStatus, ApiError> {
  return useQuery({
    queryKey: onboardingKeys.all,
    queryFn: () => api.get<OnboardingStatus>("/v1/onboarding/status"),
    // Round 14 F2 -- a connector can start failing without anyone
    // writing anything, so this cannot wait two minutes to notice.
    staleTime: 30_000,
    // Same pre-auth gating as useMe: AppShell mounts this above its
    // auth-status gate for the Getting Started nav entry.
    enabled,
  });
}
